"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-lines-per-function */
const analytics_1 = require("@completeanatomy/analytics");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const licenses_1 = require("@completeanatomy/licenses");
const ui_1 = require("@completeanatomy/ui");
const atoms_1 = require("../../atoms");
const mediaQuery_1 = require("../../cssMixins/mediaQuery");
const hooks_1 = require("../../hooks");
const useStateReducer_1 = require("../../hooks/useStateReducer");
const molecules_1 = require("../../molecules");
const MainScreenStateProvider_1 = require("../../providers/MainScreenStateProvider");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
function MainToolbar({ isSearchOpen, onClickSearch, onClickLogo, onClickDescription, showScreenName = true, isDescriptionOpen, closeDescriptionButtonRef, }) {
    const analytics = (0, analytics_1.useAnalytics)();
    const isLower = (0, ui_1.useScreenBreakpoint)(mediaQuery_1.size.tablet);
    const screenInfo = (0, hooks_1.useScreenInfo)();
    const licenses = (0, licenses_1.useUserLicenses)();
    const isLandscape = (0, ui_1.useOrientation)();
    const [, dispatch] = (0, MainScreenStateProvider_1.useMainScreenStateContext)();
    const descriptionButtonRef = (0, react_1.useRef)(null);
    const tooltipPosition = isLower ? 'right' : 'bottom';
    const hasMounted = (0, react_1.useRef)(false);
    const onClick = (state) => {
        switch (state) {
            case useStateReducer_1.TabType.Search:
                onClickSearch();
                break;
            case useStateReducer_1.TabType.Description:
                onClickDescription();
                break;
        }
        return () => {
            dispatch((0, useStateReducer_1.selectTab)(state));
        };
    };
    const onClickCopyLink = () => __awaiter(this, void 0, void 0, function* () {
        analytics.log('copy_link_pressed', {
            resource_type: 'screen',
        });
        yield navigator.clipboard.writeText(document.location.href);
    });
    const isCopyAvailable = licenses === null || licenses === void 0 ? void 0 : licenses.some(license => license.type > bridge_schema_1.LicenseType.StudentPlus);
    const handleTabNavigation = (0, react_1.useCallback)((event) => {
        if (isDescriptionOpen && event.key === 'Tab') {
            const activeElement = document.activeElement;
            const nextButton = activeElement === descriptionButtonRef.current
                ? closeDescriptionButtonRef === null || closeDescriptionButtonRef === void 0 ? void 0 : closeDescriptionButtonRef.current
                : descriptionButtonRef.current;
            nextButton === null || nextButton === void 0 ? void 0 : nextButton.focus();
            event.preventDefault();
        }
    }, [isDescriptionOpen, closeDescriptionButtonRef]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (!hasMounted.current) {
            hasMounted.current = true;
            return;
        }
        if (isDescriptionOpen) {
            (_a = closeDescriptionButtonRef === null || closeDescriptionButtonRef === void 0 ? void 0 : closeDescriptionButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            (_b = descriptionButtonRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        window.addEventListener('keydown', handleTabNavigation);
        return () => {
            window.removeEventListener('keydown', handleTabNavigation);
        };
    }, [isDescriptionOpen, closeDescriptionButtonRef, handleTabNavigation]);
    return ((0, jsx_runtime_1.jsxs)(Toolbar, { children: [(0, jsx_runtime_1.jsx)(molecules_1.Logo, { onClickLogo: onClickLogo }), (0, jsx_runtime_1.jsx)(atoms_1.Separator, {}), !isLower || isLandscape ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [screenInfo.information && ((0, jsx_runtime_1.jsx)(atoms_1.DescriptionButton, { ref: descriptionButtonRef, onClick: () => onClick(useStateReducer_1.TabType.Description), tooltipPlace: tooltipPosition })), showScreenName && ((0, jsx_runtime_1.jsx)(atoms_1.ScreenName, { name: screenInfo.name, creator: screenInfo.author })), (0, jsx_runtime_1.jsx)(atoms_1.Separator, {}), (0, jsx_runtime_1.jsxs)(IconButtons, { children: [isCopyAvailable && ((0, jsx_runtime_1.jsx)(atoms_1.CopyLinkButton, { onClick: onClickCopyLink, tooltipPlace: tooltipPosition })), (0, jsx_runtime_1.jsx)(atoms_1.SearchButton, { onClick: () => onClick(useStateReducer_1.TabType.Search), tooltipPlace: tooltipPosition, isSelected: isSearchOpen })] })] })) : (showScreenName && ((0, jsx_runtime_1.jsx)(atoms_1.ScreenName, { name: screenInfo.name, creator: screenInfo.author })))] }));
}
exports.default = MainToolbar;
const Toolbar = styled_components_1.default.div `
  padding: 4px;
  padding-left: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.grasshopper.background};
  border-radius: 4px;
  width: min-content;
  max-width: 100%;

  box-shadow: ${({ theme }) => `0px 2px 4px 0px ${theme.grasshopper.dropShadow}`};

  ${mediaQuery_1.device.mobile((0, styled_components_1.css) `
    width: 100%;
  `)};

  ${mediaQuery_1.device.tablet((0, styled_components_1.css) `
    padding-right: 8px;
    width: max-content;
    min-width: 204px;
    max-width: 100%;
  `)};

  ${ui_1.deviceMainScreen.mobileS((0, styled_components_1.css) `
    min-width: auto;
  `)};

  ${ui_1.deviceMainScreenLandscape.tablet((0, styled_components_1.css) `
    min-width: auto;
  `)};
`;
const IconButtons = styled_components_1.default.div `
  display: flex;
  gap: 4px;
`;
